/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { call, select, take } from 'redux-saga/effects';

import { createAsyncAction } from 'src/redux/actions';
import { getRepositories } from 'src/redux/dashboard/selectors/repositories';
import createGetRepositoryBuildStatuses from 'src/redux/global/sagas/create-get-repository-build-statuses';
import {
  FetchRecentlyViewedRepositories,
  FetchRecentlyViewedRepository,
} from 'src/redux/recently-viewed-repositories';
import {
  getHasDataForAllRecentlyViewedRepositories,
  getRecentlyViewedRepositories,
} from 'src/selectors/repository-selectors';

export const UPDATE_REPOSITORY_BUILD_STATUSES = createAsyncAction(
  'dashboard/update-repositories-with-build-status'
);

const fetchRecentlyViewedRepositoriesBuildStatuses =
  createGetRepositoryBuildStatuses(
    UPDATE_REPOSITORY_BUILD_STATUSES,
    getRecentlyViewedRepositories
  );

export function* getDashboardOverviewRepositoriesBuildStatuses() {
  // We might have some UUIDs in redux that map to a model that's pending fetching or that
  // no longer exists and is pending removal from redux. In order to determine when we've
  // loaded all of the recently viewed repository data, we need to wait until we have repo
  // data so we can make a single request for build statuses instead of multiple smaller ones
  let isReady: boolean = yield select(
    getHasDataForAllRecentlyViewedRepositories
  );

  while (!isReady) {
    yield take([
      FetchRecentlyViewedRepositories.SUCCESS,
      FetchRecentlyViewedRepository.SUCCESS,
      FetchRecentlyViewedRepository.ERROR,
    ]);
    isReady = yield select(getHasDataForAllRecentlyViewedRepositories);
  }

  yield call(fetchRecentlyViewedRepositoriesBuildStatuses);
}

export const getDashboardRepositoryListBuildStatuses =
  createGetRepositoryBuildStatuses(
    UPDATE_REPOSITORY_BUILD_STATUSES,
    getRepositories
  );
